// extracted by mini-css-extract-plugin
module.exports = {"description":"_99551c8aa8--description--QUltL"};